import type { AlbumType } from 'src/types';

export const checkForAlbumsWithNoSize = (album: AlbumType): boolean => (
  album.covers.every((cover) => !!cover.albumSize)
);
